<template>
  <section id="hero">
    <v-img
      :src="require('@/assets/home.webp')"
      class="white--text mr-3"
    />
    <v-container class="fill-height px-4 py-12">
      <v-responsive
        class="d-flex align-end justify-end"
        height="100%"
        width="100%"
      >
        <base-section-heading
          color="primary"
          title="A well-established company offering intra-logistics/material handling solutions and industrial/automotive lubricants."
        />

        <base-body>
          We engineer equipment applications to help customers to modernise their practices and grow their businesses. We represent an impressive line-up of brands including the premium German based JUNGHEINRICH - one of the world’s three leading companies in the material handling equipment, warehousing, and material flow engineering sectors, as well as the European leader in warehousing technology, premium France based MANITOU Group - a world leader in all-terrain material handling/dirt engaging markets and CASTROL - a British global brand of industrial and automotive lubricants.
        </base-body>

        <div
          :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
          class="d-flex flex-wrap"
        />
      </v-responsive>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>
